import React from "react";
import { setEditId, SkinInterface } from "../../../../store/roblox/skinsSlice";
import IconText from "../../../../componets/IconText";
import { HeartOutlined, LikeOutlined, MessageOutlined } from "@ant-design/icons";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import Meta from "../../Users/_partials/_Meta";
import CardImage from "../../../../componets/CardImage";
import { EntityId } from "@reduxjs/toolkit";
import { destroySkin } from "../../../../actions/roblox/skinsActions";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../store/hooks";
import { UserInterface } from "../../../../store/roblox/usersSlice";
import { formattedDate } from "../../../../helpers/DateHelpers";

interface propsInterface {
  skin: SkinInterface;
  user?: UserInterface | undefined;
}

const Card = ({ skin, user }: propsInterface) => {
  const navigate            = useNavigate();
  const dispatch            = useAppDispatch();
  const formattedCreatedAt  = formattedDate(skin.created_at);
  let className = 'v-roblox-skins__card';
  className += skin.type_id !== 4 ? ' o-placeholder' : '';

  function onClickEdit(id: EntityId)  {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroySkin(id));

    if (destroySkin.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroySkin.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <CardImage
      className={className}
      image={skin.thumbnail_url}
      title={skin.title}
      link={skin.url}
      size='medium'
      stats={[
        <IconText tooltip='popular' icon={HeartOutlined} text={skin.popular_count} />,
        <IconText tooltip='likes' icon={LikeOutlined} text={skin.likes_count} />,
        <IconText tooltip='comments' icon={MessageOutlined} text={skin.comments_count} />
      ]}
      options={[
        <ButtonEdit key={`edit-${skin.id}`} onClick={() => onClickEdit(skin.id)} />,
        <ButtonDestroy key={`destroy-${skin.id}`} onClick={() => onClickDestroy(skin.id)} />
      ]}
    >
      {user && <Meta user={user} size='xsmall' />}

      <div className='v-small_text'>
        {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
      </div>
    </CardImage>
  )
}

export default Card;
